import { ArrowPathIcon } from "@heroicons/react/24/outline";

interface ErrorFallbackProps {
  error?: Error | null;
  handleResetError: () => void;
}

const ErrorFallback = ({ error, handleResetError }: ErrorFallbackProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-20 text-center">
      <h1 className="text-xl font-bold">抱歉，發生非預期的錯誤</h1>
      <div>
        {error?.name && <p className="mt-4 text-sm text-error">{error.name}</p>}
        {error?.message && <p className="mt-2 text-sm text-error">{error.message}</p>}
      </div>
      <p className="text-secondary">
        因載入畫面時發生些許錯誤。請點擊下方「重新整理」圖示重試一次。
      </p>
      <button
        className="mt-4 flex flex-col items-center gap-2"
        onClick={handleResetError}
        type="button"
      >
        <ArrowPathIcon className="size-8" />
        <p className="text-sm text-neutral">重新整理</p>
      </button>
    </div>
  );
};

export default ErrorFallback;
